export default __webpack_public_path__ + "static/media/kominfologo.3244ce1a.png";